// TODO(keep): Refactored file to keep
export const staleTime = {
  FIVE_MINUTES: 300000,
  INFINITE: Infinity,
  ONE_DAY: 86400000,
  ONE_HOUR: 3600000,
  ONE_MINUTE: 60000,
}
